(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1069],{

/***/ 58165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/GIMS/interactive_report_new",
      function () {
        return __webpack_require__(17678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(96540);
/* harmony import */ var _mui_icons_material_ArrowBackOutlined__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(96471);
/* harmony import */ var _mui_icons_material_ArrowUpward__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(54364);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(50594);
/* harmony import */ var _mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27036);
/* harmony import */ var _mui_icons_material_MoreVert__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(57976);
/* harmony import */ var _mui_icons_material_Security__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(61235);
/* harmony import */ var markdown_to_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86243);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(21448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70877);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(85050);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(20784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(49837);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(59742);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(44731);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(79072);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(81401);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(44373);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(29620);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(76779);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(95398);
/* harmony import */ var _mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(44642);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(77745);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13264);
/* harmony import */ var _mui_x_date_pickers_AdapterDayjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(10586);
/* harmony import */ var _mui_x_date_pickers_DatePicker__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(17389);
/* harmony import */ var _mui_x_date_pickers_DateTimePicker__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(93730);
/* harmony import */ var _mui_x_date_pickers_LocalizationProvider__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(50720);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70594);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik_mui__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(20990);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34011);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_spinners__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(36529);
/* harmony import */ var typewriter_effect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5459);
/* harmony import */ var typewriter_effect__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(typewriter_effect__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74231);
/* harmony import */ var _public_assets_document_text_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15597);
/* harmony import */ var _public_assets_document_text_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_public_assets_document_text_svg__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _public_assets_email_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43109);
/* harmony import */ var _public_assets_email_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_public_assets_email_svg__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _src_tokens__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5786);
/* harmony import */ var _mui_icons_material_Send__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26307);
/* eslint-disable import/order */ /* eslint-disable no-unused-vars */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/alt-text */ /* eslint-disable camelcase */ 





































// Header on selected contact
var EntityText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 500,
        letterSpacing: ".0107142867em",
        // alignItems: 'center',
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_typography_headline */ .T.token_typography_headline,
        textAlign: "left"
    };
});
// Subheader on selected contact
var OriginText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 400,
        letterSpacing: ".0107142867em",
        // alignItems: 'center',
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_text_grey_on_grey */ .T.token_text_grey_on_grey,
        textAlign: "left"
    };
});
// Explainer on white background
var HelperText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 400,
        letterSpacing: ".0107142867em",
        // alignItems: 'center',
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_text_grey_on_white */ .T.token_text_grey_on_white,
        textAlign: "left"
    };
});
var ExampleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.80500rem",
        lineHeight: "1.00rem",
        fontWeight: 400,
        letterSpacing: ".0107142867em",
        marginTop: "5px",
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_typography_regular */ .T.token_typography_regular,
        textAlign: "left"
    };
});
// Section headers
var TopHeaderShow = (0,_mui_system__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "24px",
        lineHeight: "1.00rem",
        fontWeight: 600,
        letterSpacing: ".0107142867em",
        marginBottom: "15px",
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
        textAlign: "left"
    };
});
function interactive_report_new(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var messageEl = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var myQuestionBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var _query = router.query, agencyID = _query.agencyID, userName = _query.userName;
    var ref37 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), inputValue = ref37[0], setInputValue = ref37[1];
    var ref38 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), messagesArray = ref38[0], setMessagesArray = ref38[1];
    var ref39 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), tampBubble = ref39[0], setTampBubble = ref39[1];
    var ref40 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), openReviewModel = ref40[0], setOpenReviewModel = ref40[1];
    var ref41 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), openAddAgencyModel = ref41[0], setOpenAddAgencyModel = ref41[1];
    var ref42 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), questionBoxHeight = ref42[0], setQuestionBoxHeight = ref42[1];
    var ref43 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), getAgencyDataById = ref43[0], setGetAgencyDataById = ref43[1];
    var ref44 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), agencyTextTempSave = ref44[0], setAgencyTextTempSave = ref44[1];
    var ref45 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), allAgencyData = ref45[0], setAllAgencyData = ref45[1];
    var ref46 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), uniqueAgencyData = ref46[0], setUniqueAgencyData = ref46[1];
    var ref47 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), openBankDetailsPopUp = ref47[0], setOpenBankDetailsPopUp = ref47[1];
    var ref48 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), currentQuestionData = ref48[0], setCurrentQuestionData = ref48[1];
    var ref49 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), questionsLoading = ref49[0], setQuestionsLoading = ref49[1];
    var ref50 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), lastQuestionFlag = ref50[0], setLastQuestionFlag = ref50[1];
    // question box current height get
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (myQuestionBoxRef.current) {
            var newHeight = myQuestionBoxRef.current.clientHeight;
            setQuestionBoxHeight(newHeight);
        }
    });
    // unique agency find
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var uniqueItems = Array.from(new Set(getAgencyDataById.map(function(agency) {
            return agency === null || agency === void 0 ? void 0 : agency._id;
        }))).map(function(id) {
            return getAgencyDataById.find(function(agency) {
                return (agency === null || agency === void 0 ? void 0 : agency._id) === id;
            });
        });
        setUniqueAgencyData(uniqueItems);
    }, [
        getAgencyDataById
    ]);
    var questionsGetApi = function(questionID) {
        var questionIdPayload = questionID ? questionID : "str-001";
        setQuestionsLoading(true);
        axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/questions/".concat(questionIdPayload)).then(function(response) {
            // Store the API response in state
            setCurrentQuestionData(response.data);
            setQuestionsLoading(false);
        }).catch(function(error) {
            console.error("Error fetching data:", error);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        questionsGetApi();
    }, []);
    // for sending message by pressing enter
    var handleKeyPress = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSendMessage();
        }
    };
    // for date picker value set
    var handleOnlyDateChange = function(date) {
        setInputValue(dayjs__WEBPACK_IMPORTED_MODULE_2___default()(date).format("YYYY/MM/DD"));
    // setInputValue(dayjs(date).format('DD/MM/YYYY hh:mm:ss A'))
    };
    // for date & time picker value set
    var handleDateTimeChange = function(date) {
        setInputValue(dayjs__WEBPACK_IMPORTED_MODULE_2___default()(date).format());
    };
    // input value get
    var handleInputChange = function(e) {
        setInputValue(e.target.value);
    };
    // message sending
    var handleSendMessage = function(data, inputSetVal) {
        if ((data === null || data === void 0 ? void 0 : data.answer_text) || (inputSetVal === null || inputSetVal === void 0 ? void 0 : inputSetVal.toString()) || inputValue) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
            if (data && (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.rules) && !((ref4 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref2 = currentQuestionData.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.rules[0]) === null || ref4 === void 0 ? void 0 : ref4.secondary_question_id) && !((ref7 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref5 = currentQuestionData.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.rules[0]) === null || ref7 === void 0 ? void 0 : ref7.tertiary_question_id)) {
                var ref24, ref25, ref26, ref27, ref28;
                var findNextQuestionID = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref24 = currentQuestionData.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[0]) === null || ref25 === void 0 ? void 0 : ref25.rules.filter(function(item) {
                    if (item.primary_question_id == (data === null || data === void 0 ? void 0 : data.question_id) && item.primary_answer_id == (data === null || data === void 0 ? void 0 : data.answer_id)) {
                        return item;
                    }
                });
                questionsGetApi(findNextQuestionID === null || findNextQuestionID === void 0 ? void 0 : findNextQuestionID[0].next_question_id);
                (findNextQuestionID === null || findNextQuestionID === void 0 ? void 0 : findNextQuestionID[0].next_question_id) == "last_q" && setLastQuestionFlag(true);
                var eventData = {
                    questionID: data === null || data === void 0 ? void 0 : data.question_id,
                    answer: data === null || data === void 0 ? void 0 : data.answer_text,
                    question: (ref26 = currentTypeWriterQuestion()) === null || ref26 === void 0 ? void 0 : ref26.question,
                    pdfQuestion: (ref27 = currentTypeWriterQuestion()) === null || ref27 === void 0 ? void 0 : ref27.pdfQuestion,
                    mainHeader: (ref28 = currentTypeWriterQuestion()) === null || ref28 === void 0 ? void 0 : ref28.mainHeader,
                    answerId: data === null || data === void 0 ? void 0 : data.answer_id
                };
                setMessagesArray(function(prevMessages) {
                    return prevMessages.length === 0 ? [
                        eventData
                    ] : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prevMessages).concat([
                        eventData
                    ]);
                });
                setInputValue("");
            }
            if (!data && (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref8 = currentQuestionData.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.rules) && !((ref12 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref10 = currentQuestionData.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.rules[0]) === null || ref12 === void 0 ? void 0 : ref12.secondary_question_id) && !((ref15 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref13 = currentQuestionData.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.rules[0]) === null || ref15 === void 0 ? void 0 : ref15.tertiary_question_id)) {
                var ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40;
                questionsGetApi(currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref29 = currentQuestionData.data) === null || ref29 === void 0 ? void 0 : (ref30 = ref29[0]) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.rules) === null || ref31 === void 0 ? void 0 : (ref32 = ref31[0]) === null || ref32 === void 0 ? void 0 : ref32.next_question_id);
                (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref33 = currentQuestionData.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33[0]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.rules) === null || ref35 === void 0 ? void 0 : (ref36 = ref35[0]) === null || ref36 === void 0 ? void 0 : ref36.next_question_id) == "last_q" && setLastQuestionFlag(true);
                var eventData1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                    questionID: (ref37 = currentTypeWriterQuestion()) === null || ref37 === void 0 ? void 0 : ref37.questionID,
                    answer: (inputSetVal === null || inputSetVal === void 0 ? void 0 : inputSetVal.toString()) || inputValue,
                    question: (ref38 = currentTypeWriterQuestion()) === null || ref38 === void 0 ? void 0 : ref38.question,
                    pdfQuestion: (ref39 = currentTypeWriterQuestion()) === null || ref39 === void 0 ? void 0 : ref39.pdfQuestion,
                    mainHeader: (ref40 = currentTypeWriterQuestion()) === null || ref40 === void 0 ? void 0 : ref40.mainHeader
                }, (inputSetVal === null || inputSetVal === void 0 ? void 0 : inputSetVal.toString()) && {
                    shownData: true
                });
                setMessagesArray(function(prevMessages) {
                    return prevMessages.length === 0 ? [
                        eventData1
                    ] : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prevMessages).concat([
                        eventData1
                    ]);
                });
                setInputValue("");
            }
            if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref16 = currentQuestionData.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.rules) && ((ref20 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref18 = currentQuestionData.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.rules[0]) === null || ref20 === void 0 ? void 0 : ref20.secondary_question_id) && ((ref23 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref21 = currentQuestionData.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[0]) === null || ref22 === void 0 ? void 0 : ref22.rules[0]) === null || ref23 === void 0 ? void 0 : ref23.tertiary_question_id)) {
                var secondaryQuestionIdFind = tampBubble.flat().find(function(item) {
                    var ref, ref1, ref2;
                    return item.questionID === ((ref2 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.rules[0]) === null || ref2 === void 0 ? void 0 : ref2.secondary_question_id);
                });
                var tertiaryQuestionId = tampBubble.flat().find(function(item) {
                    var ref, ref1, ref2;
                    return item.questionID === ((ref2 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.rules[0]) === null || ref2 === void 0 ? void 0 : ref2.tertiary_question_id);
                });
                if (secondaryQuestionIdFind) {
                    var ref41, ref42, ref43, ref44;
                    var findNextQuestionID1 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref41 = currentQuestionData.data) === null || ref41 === void 0 ? void 0 : (ref42 = ref41[0]) === null || ref42 === void 0 ? void 0 : ref42.rules.filter(function(item) {
                        if ((item === null || item === void 0 ? void 0 : item.secondary_answer_id) == (secondaryQuestionIdFind === null || secondaryQuestionIdFind === void 0 ? void 0 : secondaryQuestionIdFind.answerId)) {
                            return item;
                        }
                    });
                    (findNextQuestionID1 === null || findNextQuestionID1 === void 0 ? void 0 : (ref43 = findNextQuestionID1[0]) === null || ref43 === void 0 ? void 0 : ref43.next_question_id) && questionsGetApi(findNextQuestionID1 === null || findNextQuestionID1 === void 0 ? void 0 : (ref44 = findNextQuestionID1[0]) === null || ref44 === void 0 ? void 0 : ref44.next_question_id);
                }
                if (tertiaryQuestionId) {
                    var ref45, ref46, ref47, ref48;
                    var findNextQuestionID2 = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref45 = currentQuestionData.data) === null || ref45 === void 0 ? void 0 : (ref46 = ref45[0]) === null || ref46 === void 0 ? void 0 : ref46.rules.filter(function(item) {
                        if ((item === null || item === void 0 ? void 0 : item.tertiary_answer_id) == (secondaryQuestionIdFind === null || secondaryQuestionIdFind === void 0 ? void 0 : secondaryQuestionIdFind.answerId)) {
                            return item;
                        }
                    });
                    (findNextQuestionID2 === null || findNextQuestionID2 === void 0 ? void 0 : (ref47 = findNextQuestionID2[0]) === null || ref47 === void 0 ? void 0 : ref47.tertiary_next_question_id) && questionsGetApi(findNextQuestionID2 === null || findNextQuestionID2 === void 0 ? void 0 : (ref48 = findNextQuestionID2[0]) === null || ref48 === void 0 ? void 0 : ref48.tertiary_next_question_id);
                }
            }
        }
    };
    var answerFormatCheck = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.answer_format) === null || ref2 === void 0 ? void 0 : ref2.trim()) == "alphanumeric") {
            return "alphanumeric";
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref3 = currentQuestionData.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.answer_format) === null || ref5 === void 0 ? void 0 : ref5.trim()) == "numeric") {
            return "number";
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref6 = currentQuestionData.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.answer_format) === null || ref8 === void 0 ? void 0 : ref8.trim()) == "text") {
            return "text";
        }
    };
    // bubble array set
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        // Create a map to store the grouped data
        var groupedData = new Map();
        // Iterate through the original array
        messagesArray.forEach(function(item) {
            // Extract the first 3 characters of questionID
            var questionIDPrefix = item.questionID.substring(0, 3);
            // Use mainHeader or "NoHeader" if it's null
            var mainHeader = item.mainHeader || "NoHeader";
            // Create a unique key based on the combination of questionID and mainHeader
            var key = "".concat(questionIDPrefix, "-").concat(mainHeader);
            // Check if the key exists in the map
            if (!groupedData.has(key)) {
                // If not, initialize it as an empty array
                groupedData.set(key, []);
            }
            // Add the item to the corresponding subarray
            groupedData.get(key).push(item);
        });
        // Convert the map values into an array of subarrays
        var groupedArray = Array.from(groupedData.values());
        // Now, groupedArray contains subarrays of objects based on the first 3 characters of questionID and mainHeader
        setTampBubble(groupedArray);
    }, [
        messagesArray
    ]);
    // intro question manage
    var handleIntroQuestion = function() {
        var ref, ref1, ref2;
        questionsGetApi(currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rules) === null || ref2 === void 0 ? void 0 : ref2[0].next_question_id);
    };
    // unKnown messages function
    var handleUnKnownMessage = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        questionsGetApi(currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rules) === null || ref2 === void 0 ? void 0 : ref2[0].next_question_id);
        var eventData = {
            questionID: (ref3 = currentTypeWriterQuestion()) === null || ref3 === void 0 ? void 0 : ref3.questionID,
            answer: "unKnown",
            question: (ref4 = currentTypeWriterQuestion()) === null || ref4 === void 0 ? void 0 : ref4.question,
            pdfQuestion: (ref5 = currentTypeWriterQuestion()) === null || ref5 === void 0 ? void 0 : ref5.pdfQuestion,
            mainHeader: (ref6 = currentTypeWriterQuestion()) === null || ref6 === void 0 ? void 0 : ref6.mainHeader
        };
        setMessagesArray(function(prevMessages) {
            return prevMessages.length === 0 ? [
                eventData
            ] : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prevMessages).concat([
                eventData
            ]);
        });
        setInputValue("");
        (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref7 = currentQuestionData.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rules) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.next_question_id) == "last_q" && setLastQuestionFlag(true);
    };
    // input filed return function
    var inputGenerator = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.answer_type) === null || ref2 === void 0 ? void 0 : ref2.trim()) == "selection") {
            var ref18, ref19, ref20, ref21, ref22, ref23;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        sx: {
                            p: "5px 0px",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            borderRadius: "40px",
                            flexWrap: {
                                xs: "nowrap",
                                md: "wrap"
                            },
                            overflow: "auto",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        },
                        children: currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref18 = currentQuestionData.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.answers) === null || ref20 === void 0 ? void 0 : ref20.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                sx: {
                                    margin: "5px 5px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    sx: {
                                        backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
                                        color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        fontWeight: 500,
                                        "&:hover": {
                                            backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_secondary */ .T.palette_secondary
                                        }
                                    },
                                    label: item === null || item === void 0 ? void 0 : item.answer_text,
                                    icon: (item === null || item === void 0 ? void 0 : item.answer_text.toLowerCase()) === "yes" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            sx: {
                                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                                fontSize: 20
                                            }
                                        })
                                    }) : (item === null || item === void 0 ? void 0 : item.answer_text.toLowerCase()) === "no" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            sx: {
                                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                                fontSize: 20,
                                                lineHeight: "24px"
                                            }
                                        })
                                    }) : null,
                                    onClick: function() {
                                        {
                                            handleSendMessage(item);
                                        }
                                    }
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref21 = currentQuestionData.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[0]) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.usage) === null || ref23 === void 0 ? void 0 : ref23.trim()) == "optional" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            variant: "contained",
                            sx: {
                                textTransform: "none"
                            },
                            onClick: function() {
                                handleUnKnownMessage();
                            },
                            children: "unKnown"
                        })
                    })
                ]
            });
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref3 = currentQuestionData.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.answer_type) === null || ref5 === void 0 ? void 0 : ref5.trim()) == "startq") {
            var ref24, ref25, ref26;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    sx: {
                        p: "5px 0px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        borderRadius: "40px",
                        flexWrap: {
                            xs: "nowrap",
                            md: "wrap"
                        },
                        overflow: "auto",
                        "&::-webkit-scrollbar": {
                            display: "none"
                        }
                    },
                    children: currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref24 = currentQuestionData.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24[0]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.answers) === null || ref26 === void 0 ? void 0 : ref26.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            sx: {
                                margin: "5px 5px"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                sx: {
                                    backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
                                    color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    fontWeight: 500,
                                    "&:hover": {
                                        backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_secondary */ .T.palette_secondary
                                    }
                                },
                                label: item === null || item === void 0 ? void 0 : item.answer_text,
                                onClick: function() {
                                    {
                                        handleIntroQuestion();
                                    }
                                }
                            })
                        });
                    })
                })
            });
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref6 = currentQuestionData.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.answer_type) === null || ref8 === void 0 ? void 0 : ref8.trim()) == "entery") {
            var ref27, ref28, ref29;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    // background: { xs: 'transparent', sm: 'transparent' },
                    backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                    borderRadius: {
                        xs: "15px",
                        sm: "15px"
                    },
                    border: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_search_border_grey */ .T.token_search_border_grey),
                    padding: {
                        xs: "4px 8px 0px 8px",
                        sm: "4px 8px 0px 8px"
                    },
                    height: "130px",
                    // margin: '15px 30px 30px 30px',
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        sx: {
                            height: "80px",
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: {
                                xs: "15px 15px 0px 0px",
                                sm: "15px 15px 0px 0px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                            sx: {
                                height: "100%",
                                width: "100%",
                                alignItems: "flex-start",
                                backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                borderRadius: "4px"
                            },
                            placeholder: "Message",
                            inputProps: {
                                "aria-label": "Message"
                            },
                            value: inputValue,
                            onChange: function(e) {
                                return handleInputChange(e);
                            },
                            onKeyPress: handleKeyPress,
                            multiline: true,
                            rows: 3,
                            autoFocus: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderTop: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_search_border_grey */ .T.token_search_border_grey),
                            height: "50px",
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: {
                                xs: "0px 0px 15px 15px",
                                sm: "0px 0px 15px 15px"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    children: (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref27 = currentQuestionData.data) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.usage) === null || ref29 === void 0 ? void 0 : ref29.trim()) == "optional" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        variant: "contained",
                                        sx: {
                                            textTransform: "none",
                                            borderRadius: "30px",
                                            marginRight: "20px",
                                            padding: "5px 15px"
                                        },
                                        onClick: function() {
                                            handleUnKnownMessage();
                                        },
                                        children: "Unknown"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    disableElevation: true,
                                    variant: "contained",
                                    onClick: function() {
                                        return handleSendMessage();
                                    },
                                    endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Send__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}),
                                    sx: {
                                        height: "32px",
                                        textTransform: "none",
                                        borderRadius: "8px"
                                    },
                                    children: "Send"
                                })
                            })
                        ]
                    })
                ]
            });
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref9 = currentQuestionData.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.answer_type) === null || ref11 === void 0 ? void 0 : ref11.trim()) == "date_time_picker") {
            var ref30, ref31, ref32;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        elevation: 0,
                        component: "form",
                        sx: {
                            p: "5px 0px 5px 15px",
                            display: "flex",
                            alignItems: "center",
                            width: "calc(100% - 60px)",
                            // height: '56px',
                            borderRadius: "30px",
                            flexWrap: "wrap"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_LocalizationProvider__WEBPACK_IMPORTED_MODULE_24__/* .LocalizationProvider */ ._, {
                            dateAdapter: _mui_x_date_pickers_AdapterDayjs__WEBPACK_IMPORTED_MODULE_25__/* .AdapterDayjs */ .y,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_DateTimePicker__WEBPACK_IMPORTED_MODULE_26__/* .DateTimePicker */ .x, {
                                value: inputValue,
                                onChange: handleDateTimeChange,
                                slotProps: {
                                    textField: {
                                        variant: "standard"
                                    }
                                },
                                InputProps: {
                                    disableUnderline: true
                                },
                                sx: {
                                    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                                        borderBottom: "none"
                                    }
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref30 = currentQuestionData.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30[0]) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.usage) === null || ref32 === void 0 ? void 0 : ref32.trim()) == "optional" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            disableElevation: true,
                            variant: "contained",
                            sx: {
                                textTransform: "none"
                            },
                            onClick: function() {
                                handleUnKnownMessage();
                            },
                            children: "Unknown"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        color: "primary",
                        component: "span",
                        sx: WebStyle.send_icon,
                        onClick: function() {
                            handleSendMessage();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowUpward__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {})
                    })
                ]
            });
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref12 = currentQuestionData.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.answer_type) === null || ref14 === void 0 ? void 0 : ref14.trim()) == "date_picker") {
            var ref33, ref34, ref35;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        elevation: 0,
                        component: "form",
                        sx: {
                            p: "5px 0px 5px 15px",
                            display: "flex",
                            alignItems: "center",
                            width: "calc(100% - 60px)",
                            // height: '56px',
                            borderRadius: "40px",
                            flexWrap: "wrap"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_LocalizationProvider__WEBPACK_IMPORTED_MODULE_24__/* .LocalizationProvider */ ._, {
                            dateAdapter: _mui_x_date_pickers_AdapterDayjs__WEBPACK_IMPORTED_MODULE_25__/* .AdapterDayjs */ .y,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_DatePicker__WEBPACK_IMPORTED_MODULE_29__/* .DatePicker */ .M, {
                                value: inputValue,
                                onChange: handleOnlyDateChange,
                                slotProps: {
                                    textField: {
                                        variant: "standard"
                                    }
                                },
                                InputProps: {
                                    disableUnderline: true
                                },
                                sx: {
                                    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                                        borderBottom: "none"
                                    }
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref33 = currentQuestionData.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33[0]) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.usage) === null || ref35 === void 0 ? void 0 : ref35.trim()) == "optional" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            disableElevation: true,
                            variant: "contained",
                            sx: {
                                textTransform: "none"
                            },
                            onClick: function() {
                                handleUnKnownMessage();
                            },
                            children: "Unknown"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                        color: "primary",
                        component: "span",
                        sx: WebStyle.send_icon,
                        onClick: function() {
                            handleSendMessage();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowUpward__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {})
                    })
                ]
            });
        }
        if ((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref15 = currentQuestionData.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.answer_type) === null || ref17 === void 0 ? void 0 : ref17.trim()) == "function") {
            var ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44;
            var lastDightFetch = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref36 = currentQuestionData.data) === null || ref36 === void 0 ? void 0 : (ref37 = ref36[0]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.question_id) === null || ref38 === void 0 ? void 0 : ref38.charAt((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref39 = currentQuestionData.data) === null || ref39 === void 0 ? void 0 : (ref40 = ref39[0]) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.question_id) === null || ref41 === void 0 ? void 0 : ref41.length) - 1);
            var changeId = (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref42 = currentQuestionData.data) === null || ref42 === void 0 ? void 0 : (ref43 = ref42[0]) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.question_id) === null || ref44 === void 0 ? void 0 : ref44.slice(0, -1)) + (lastDightFetch - 1);
            var foundItem = tampBubble.flat().find(function(item) {
                return item.questionID === changeId;
            });
            var birthdate = new Date(foundItem === null || foundItem === void 0 ? void 0 : foundItem.answer);
            var currentDate = new Date();
            var timeDifference = currentDate - birthdate;
            var ageDate = new Date(timeDifference);
            var years = Math.abs(ageDate.getUTCFullYear() - 1970);
            handleSendMessage(undefined, years);
        }
    };
    // show current question
    var currentTypeWriterQuestion = function() {
        var ref;
        var tempQuestion;
        var questionDetails = currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : ref[0];
        if (questionDetails) {
            tempQuestion = {
                questionID: questionDetails === null || questionDetails === void 0 ? void 0 : questionDetails.question_id,
                question: questionDetails === null || questionDetails === void 0 ? void 0 : questionDetails.question_text,
                pdfQuestion: questionDetails === null || questionDetails === void 0 ? void 0 : questionDetails.pdf_header,
                helperText: questionDetails === null || questionDetails === void 0 ? void 0 : questionDetails.helper_text,
                mainHeader: questionDetails === null || questionDetails === void 0 ? void 0 : questionDetails.report_header
            };
            return tempQuestion;
        }
    };
    // agency model state management
    var handleAddAgencyOpen = function() {
        setOpenAddAgencyModel(true);
    };
    var handleAddAgencyClose = function() {
        setOpenAddAgencyModel(false);
    };
    // manage selected agency remove
    var remainingAgencies = allAgencyData.filter(function(agency) {
        return !getAgencyDataById.includes(agency);
    });
    var uniqueIds = new Set(getAgencyDataById.map(function(item) {
        return item === null || item === void 0 ? void 0 : item._id;
    }));
    var filteredArrayAgency = remainingAgencies.filter(function(item) {
        return !uniqueIds.has(item._id);
    });
    // delete agency in array
    var deleteByIdAgent = function(id) {
        setGetAgencyDataById(function(oldValues) {
            return oldValues.filter(function(array) {
                return (array === null || array === void 0 ? void 0 : array._id) !== id;
            });
        });
    };
    // selected all agency id find
    var selectedAllArrayIdFind = getAgencyDataById.map(function(item) {
        return item === null || item === void 0 ? void 0 : item._id;
    });
    // agency model click before data store in state
    var handleAgencyDataClick = function(data) {
        if (data === null || data === void 0 ? void 0 : data.isBank) {
            handleAddAgencyClose();
            handleBankDetailsPopUpOpen();
            setAgencyTextTempSave(data);
            setGetAgencyDataById(function(prev) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prev).concat([
                    data
                ]);
            });
        } else {
            setGetAgencyDataById(function(prev) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prev).concat([
                    data
                ]);
            });
            handleAddAgencyClose();
        }
    };
    // bank details model state management
    var handleBankDetailsPopUpOpen = function() {
        setOpenBankDetailsPopUp(true);
    };
    var handleBankDetailsPopUpClose = function() {
        setOpenBankDetailsPopUp(false);
        var updatedData = getAgencyDataById.filter(function(item) {
            return item._id !== agencyTextTempSave._id;
        });
        setGetAgencyDataById(updatedData);
    };
    // Account details form forMik manage
    var initialValues = {
        bankAccountNumber: "",
        bankAccountPin: "",
        bankPassword: ""
    };
    var validationSchema = yup__WEBPACK_IMPORTED_MODULE_8__/* .object */ .Ry().shape({
        bankAccountNumber: yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_().required("Required"),
        bankAccountPin: yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_().required("Required"),
        bankPassword: yup__WEBPACK_IMPORTED_MODULE_8__/* .string */ .Z_().required("Required")
    });
    var onSubmit = function(values) {
        var payload = {
            bankAccountNumber: values === null || values === void 0 ? void 0 : values.bankAccountNumber,
            bankAccountPin: values === null || values === void 0 ? void 0 : values.bankAccountPin,
            bankPassword: values === null || values === void 0 ? void 0 : values.bankPassword
        };
        axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].post */ .Z.post("/api/bank/details", payload).then(function(response) {
            setGetAgencyDataById(function(prev) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(prev).concat([
                    agencyTextTempSave
                ]);
            });
            handleAddAgencyClose();
            setOpenBankDetailsPopUp(false);
        }).catch(function(error) {
            console.error(error);
        });
    };
    // review model manage
    var handleOpenReviewModel = function() {
        setOpenReviewModel(true);
    };
    var handleCloseReviewModel = function() {
        setOpenReviewModel(false);
    };
    // email open
    var handleEmailButtonClick = function() {
        var mailtoUrl = "mailto:";
        window.open(mailtoUrl);
    };
    // outside click model not close
    var handleBackdropClick = function(event) {
        // Prevent closing the dialog when clicking outside
        event.stopPropagation();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (messageEl) {
            messageEl.current.addEventListener("DOMNodeInserted", function(event) {
                var target = event.currentTarget;
                target.scroll({
                    top: target.scrollHeight
                });
            });
        }
    }, []);
    // page back route setup
    var handleBack = function() {
        router.push("/blockquiry_connect/u/select_agency");
        window.location.href = "/blockquiry_connect/u/select_agency";
    };
    // image/pdf upload
    var handleImageUpload = function(event) {
        var _loop = function(i) {
            var file = files[i];
            var reader = new FileReader();
            if (file.size > (currentIndexNewA === null || currentIndexNewA === void 0 ? void 0 : currentIndexNewA.maxSize)) {
                alert("File maximum size limit of 5 MB.");
                return "continue" // Skip processing this file and move to the next one
                ;
            }
            reader.onloadend = function() {
                handleReaderLoadEnd(reader, file);
            };
            reader.readAsDataURL(file);
        };
        var files = event.target.files;
        var totalFiles = files.length;
        // Array to store base64 encoded data of all selected files
        var base64ImagesTemp = [];
        var filesProcessed = 0;
        var handleReaderLoadEnd = function(reader, file) {
            // Callback when the file reading is completed
            var base64String = reader.result;
            base64ImagesTemp.push(base64String);
            filesProcessed++;
            if (filesProcessed === totalFiles) {
                // All files have been processed, update the state with the base64Images array
                setBase64Image(base64ImagesTemp);
                // Perform your logic with the base64Images array (e.g., send it to the server)
                // Call handleSendMessage() or any other function that requires the base64Images array.
                handleSendMessage();
            }
        };
        for(var i = 0; i < totalFiles; i++)_loop(i);
    };
    // Agency data get request( all agency)
    var getAgencyDataApi = function() {
        axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/agencies").then(function(response) {
            // Store the API response in state
            setAllAgencyData(response.data);
        }).catch(function(error) {
            console.error("Error fetching data:", error);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        getAgencyDataApi();
    }, []);
    // submit report api integration
    var handleSubmitReport = function() {
        var payload = {
            // agencyID: agencyID,
            agencyID: selectedAllArrayIdFind,
            report: tampBubble,
            name: userName
        };
        axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].post */ .Z.post("/api/reports", payload).then(function(response) {
            router.push("/blockquiry_connect/u/select_agency");
        }).catch(function(error) {
            console.error("Error fetching data:", error);
        });
    };
    // agency data get request (selected agency)
    var getAgencyDataApiById = function() {
        if (agencyID) {
            axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get("/api/agencies/".concat(agencyID)).then(function(response) {
                setGetAgencyDataById([
                    response.data.data
                ]); // Store the API response in state
            }).catch(function(error) {
                console.error("Error fetching data:", error);
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (agencyID) {
            getAgencyDataApiById();
        }
    }, [
        agencyID
    ]);
    // page style
    var WebStyle = {
        bot_chat_all_message: {
            width: "100vw",
            height: "100vh",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none"
            }
        },
        chat_message_send: {
            borderRadius: "30px",
            width: "fit-content",
            // COLOR OF THE QUESTION INNER BORDER
            backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_300 */ .T.token_grey_300,
            // COLOR OF THE QUESTION OUTER BORDER
            border: "2px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface),
            wordBreak: "break-all",
            margin: "10px 0",
            color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_secondary */ .T.palette_secondary,
            fontWeight: "500",
            // padding: '15px 25px',
            display: "flex",
            flexDirection: "column",
            textAlign: "start"
        },
        message_font: {
            fontSize: "16px",
            fontWeight: 500,
            // COLOR OF THE QUESTION FONT
            color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary
        },
        message_font_header: {
            fontSize: "20px",
            fontWeight: 600,
            color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface
        },
        message_answer: {
            fontSize: "16px",
            fontWeight: 500,
            // COLOR OF THE USER RESPONSE FONT
            color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface
        },
        message_answer_review: {
            fontSize: "16px",
            fontWeight: 500,
            // COLOR OF THE USER RESPONSE FONT
            // color: tokens.token_surface,
            color: "rgba(0, 0, 0, 0.40)"
        },
        send_icon: {
            backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
            color: "#FFFFFF",
            height: "54px",
            marginRight: "6px",
            width: "54px",
            "&:hover": {
                backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_secondary */ .T.palette_secondary,
                color: "#FFFFFF"
            },
            "&.Mui-disabled": {
                color: "white",
                backgroundColor: "rgba(11, 43, 59, 0.8)"
            }
        },
        startHindQHelperText: {
            fontSize: "16px",
            fontWeight: "500",
            borderRadius: "20px",
            border: "1px solid rgb(204, 204, 204)",
            padding: "25px",
            boxShadow: "0px 3px 3px - 2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
            backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_100 */ .T.token_grey_100,
            margin: "0",
            maxWidth: "650px"
        }
    };
    var extractContent = function(input, tagName) {
        var regex = new RegExp("<".concat(tagName, ">(.*?)<\\/").concat(tagName, ">"), "g");
        var matches = [];
        var match;
        while((match = regex.exec(input)) !== null){
            matches.push(match[1]);
        }
        return matches;
    };
    var helperTextShow = function() {
        var ref, ref1, ref2, ref3;
        var titleContent = extractContent((ref = currentTypeWriterQuestion()) === null || ref === void 0 ? void 0 : ref.helperText, "title");
        var bulletContent = extractContent((ref1 = currentTypeWriterQuestion()) === null || ref1 === void 0 ? void 0 : ref1.helperText, "bullet");
        var numericContent = extractContent((ref2 = currentTypeWriterQuestion()) === null || ref2 === void 0 ? void 0 : ref2.helperText, "numeric");
        var alphanumericContent = extractContent((ref3 = currentTypeWriterQuestion()) === null || ref3 === void 0 ? void 0 : ref3.helperText, "alphanumeric");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                titleContent.length > 0 && titleContent.map(function(content, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: content
                    }, index);
                }),
                bulletContent.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    style: {
                        paddingLeft: "16px",
                        margin: "0px"
                    },
                    children: bulletContent.map(function(content, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: content
                        }, index);
                    })
                }),
                numericContent.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    children: numericContent.map(function(content, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: content
                        }, index);
                    })
                }),
                alphanumericContent.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    type: "A",
                    children: alphanumericContent.map(function(content, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: content
                        }, index);
                    })
                })
            ]
        });
    // {
    //   alphanumericContent.length > 0 && (
    //     <ol type="A">
    //       {alphanumericContent.map((content, index) => (
    //         <li key={index}>{content}</li>
    //       ))}
    //     </ol>
    //   )
    // }
    // const helperText = currentTypeWriterQuestion()?.helperText || '';
    // const roundBulletShow = helperText.split('\\b');
    // const alphabetShow = helperText.split('\\a');
    // const numberShow = helperText.split('\\n');
    // if (roundBulletShow?.length > 1) {
    //   return (
    //     <>
    //       <ul style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {roundBulletShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ul>
    //     </>
    //   );
    // } else if (alphabetShow?.length > 1) {
    //   return (
    //     <>
    //       <ol type="A" style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {alphabetShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ol>
    //     </>
    //   );
    // } else if (numberShow?.length > 1) {
    //   return (
    //     <>
    //       <ol style={{ paddingLeft: '16px', margin: '0px' }}>
    //         {numberShow.map((line, index) => (
    //           <li key={index}>{line}</li>
    //         ))}
    //       </ol>
    //     </>
    //   );
    // } else {
    //   return currentTypeWriterQuestion()?.helperText;
    // }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        sx: WebStyle.bot_chat_all_message,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                position: "sticky",
                sx: {
                    width: {
                        sm: "100%"
                    },
                    bgcolor: "white"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowBackOutlined__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                            sx: {
                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
                                cursor: "pointer",
                                width: "24px",
                                height: "24px",
                                marginRight: "16px"
                            },
                            onClick: function() {
                                handleBack();
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                            elevation: 0,
                            sx: {
                                backgroundColor: "transparent",
                                display: "flex",
                                alignItems: "center",
                                overflow: "auto",
                                "&::-webkit-scrollbar": {
                                    display: "none"
                                }
                            },
                            children: [
                                uniqueAgencyData && uniqueAgencyData.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                // background: '#EAEAEA',
                                                // BACKGROUND OF THE SELECTED CONTACT
                                                backgroundColor: "rgba(234, 234, 234, 0.6)",
                                                padding: "6px 12px",
                                                borderRadius: "6px",
                                                marginRight: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                                    sx: {
                                                        padding: 0,
                                                        whiteSpace: "nowrap",
                                                        marginRight: "4px"
                                                    },
                                                    avatar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                                        variant: "rounded",
                                                        src: item === null || item === void 0 ? void 0 : item.image,
                                                        alt: "country-flag",
                                                        sx: {
                                                            width: 32,
                                                            height: 24,
                                                            border: "1px solid transparent"
                                                        }
                                                    }),
                                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EntityText, {
                                                        sx: {
                                                            fontSize: "0.775rem",
                                                            lineHeight: "1.00rem"
                                                        },
                                                        children: item === null || item === void 0 ? void 0 : item.label
                                                    }),
                                                    subheader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OriginText, {
                                                        sx: {
                                                            fontSize: "0.775rem",
                                                            lineHeight: "0.975rem"
                                                        },
                                                        children: item === null || item === void 0 ? void 0 : item.location
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                    sx: {
                                                        display: "flex"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                        sx: {
                                                            height: "20px",
                                                            width: "20px",
                                                            borderRadius: "100%",
                                                            cursor: "pointer",
                                                            marginLeft: "6px"
                                                        },
                                                        onClick: function() {
                                                            return deleteByIdAgent(item === null || item === void 0 ? void 0 : item._id);
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    });
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                                    sx: {
                                        cursor: "pointer",
                                        borderRadius: "100%",
                                        fontSize: "28px"
                                    },
                                    onClick: handleAddAgencyOpen
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            flexGrow: 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                            "aria-label": "settings",
                            sx: {
                                display: "flex",
                                justifyContent: "space-between"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_MoreVert__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                sx: {
                    padding: "20px",
                    // backgroundColor: 'rgba(231,233,235,255)',
                    // ENTIRE UI BACKGROUND COLOR
                    backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                    height: {
                        xs: "calc(100vh - 56px)",
                        md: "calc(100vh - 64px)"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                    container: true,
                    columnSpacing: 3,
                    sx: {
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                height: {
                                    xs: "100px",
                                    md: "100%"
                                },
                                marginBottom: "20px"
                            }, (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref = currentQuestionData.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.answer_type) === null || ref2 === void 0 ? void 0 : ref2.trim()) == "startq" ? {
                                display: "none"
                            } : ""),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                sx: {
                                    // backgroundColor: 'rgba(255,255,255,255)',
                                    // BACKGROUND COLOR OF THE HELPER TEXT
                                    backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                    border: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_300 */ .T.token_grey_300),
                                    borderRadius: "16px",
                                    padding: "16px",
                                    height: {
                                        xs: "100px",
                                        md: "100%"
                                    },
                                    overflow: "auto",
                                    "&::-webkit-scrollbar": {
                                        display: "none"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelperText, {
                                    children: ((ref3 = currentTypeWriterQuestion()) === null || ref3 === void 0 ? void 0 : ref3.helperText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(markdown_to_jsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        children: (ref4 = currentTypeWriterQuestion()) === null || ref4 === void 0 ? void 0 : ref4.helperText
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            md: (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref5 = currentQuestionData.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.answer_type) === null || ref7 === void 0 ? void 0 : ref7.trim()) == "startq" ? 12 : 6,
                            sx: {
                                height: {
                                    xs: "calc(100vh - 224px)",
                                    md: "100%"
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                // Right hand side box with input and Q & A
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    borderRadius: "16px",
                                    height: {
                                        xs: "calc(100vh - 224px)",
                                        md: "100%"
                                    },
                                    overflow: "auto",
                                    "&::-webkit-scrollbar": {
                                        display: "none"
                                    }
                                },
                                ref: messageEl,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        sx: {
                                            // MESSAGES AREA BACKGROUND COLOR
                                            backgroundColor: (tampBubble === null || tampBubble === void 0 ? void 0 : tampBubble.length) === 0 ? _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface : _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface,
                                            // : 'rgb(238, 238, 238)',
                                            // ? 'rgba(231,233,235,255)'
                                            borderRadius: "16px",
                                            display: "".concat((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref8 = currentQuestionData.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.answer_type) === null || ref10 === void 0 ? void 0 : ref10.trim()) == "startq" && "flex"),
                                            justifyContent: "".concat((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref11 = currentQuestionData.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.answer_type) === null || ref13 === void 0 ? void 0 : ref13.trim()) == "startq" ? "center" : "flex-end"),
                                            alignItems: "".concat((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref14 = currentQuestionData.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.answer_type) === null || ref16 === void 0 ? void 0 : ref16.trim()) == "startq" && "center")
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            // Question and answer box
                                            sx: {
                                                minHeight: {
                                                    xs: "calc(100vh - (".concat(questionBoxHeight, "px + 245px))"),
                                                    md: "calc(100vh - (".concat(questionBoxHeight, "px + 124px))")
                                                },
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "".concat((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref17 = currentQuestionData.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.answer_type) === null || ref19 === void 0 ? void 0 : ref19.trim()) == "startq" ? "center" : "flex-start"),
                                                alignItems: "".concat((currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref20 = currentQuestionData.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.answer_type) === null || ref22 === void 0 ? void 0 : ref22.trim()) == "startq" ? "center" : "flex-end")
                                            },
                                            children: [
                                                (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref23 = currentQuestionData.data) === null || ref23 === void 0 ? void 0 : (ref24 = ref23[0]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.answer_type) === null || ref25 === void 0 ? void 0 : ref25.trim()) == "startq" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                    sx: WebStyle.startHindQHelperText,
                                                    children: ((ref26 = currentTypeWriterQuestion()) === null || ref26 === void 0 ? void 0 : ref26.helperText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(markdown_to_jsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                        children: (ref27 = currentTypeWriterQuestion()) === null || ref27 === void 0 ? void 0 : ref27.helperText
                                                    })
                                                }),
                                                messagesArray.filter(function(item) {
                                                    return item.shownData !== true;
                                                }).map(function(data) {
                                                    var ref;
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            sx: WebStyle.chat_message_send,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        sx: {
                                                                            margin: "12px",
                                                                            // QUESTION BACKGROUND COLOR
                                                                            // background: 'rgb(238, 238, 238)',
                                                                            background: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_100 */ .T.token_grey_100,
                                                                            padding: "12px 12px 12px 15px",
                                                                            border: "1px solid ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_surface */ .T.token_surface, ")"),
                                                                            // border: `1px solid rgb(204, 204, 204)`,
                                                                            borderRadius: "20px 20px 0 0"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            style: WebStyle.message_font,
                                                                            children: data === null || data === void 0 ? void 0 : data.question
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        background: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary,
                                                                        padding: "10px 20px",
                                                                        borderRadius: "0px 0px 30px 30px"
                                                                    },
                                                                    children: typeof (data === null || data === void 0 ? void 0 : data.answer) === "object" ? data === null || data === void 0 ? void 0 : (ref = data.answer) === null || ref === void 0 ? void 0 : ref.map(function(answerData) {
                                                                        return answerData.includes("image") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: answerData,
                                                                            style: {
                                                                                borderRadius: "10px",
                                                                                margin: "2px"
                                                                            },
                                                                            height: "auto",
                                                                            width: "190",
                                                                            alt: "Converted to Base64"
                                                                        }) : answerData.includes("application/pdf") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("embed", {
                                                                            src: answerData,
                                                                            type: "application/pdf",
                                                                            style: {
                                                                                borderRadius: "10px",
                                                                                margin: "2px"
                                                                            },
                                                                            width: "350px",
                                                                            height: "300px"
                                                                        }) : "";
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            style: WebStyle.message_answer,
                                                                            children: data.answer
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    });
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        sx: {
                                            position: "sticky",
                                            bottom: "0",
                                            borderRadius: "16px"
                                        },
                                        children: !lastQuestionFlag ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_39__/* ["default"] */ .Z, {
                                            elevation: 3,
                                            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                                width: "100%",
                                                // INPUT AREA BACKGROUND COLOR
                                                backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_100 */ .T.token_grey_100,
                                                // backgroundColor: 'rgb(238, 238, 238)',
                                                border: "1px solid rgb(204, 204, 204)",
                                                // boxShadow: '0 4px 12px rgb(32 33 36 / 28%)',
                                                borderRadius: "16px",
                                                position: "sticky",
                                                bottom: 0,
                                                marginTop: "20px",
                                                padding: "25px 25px 25px 25px"
                                            }, (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref28 = currentQuestionData.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28[0]) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.answer_type) === null || ref30 === void 0 ? void 0 : ref30.trim()) == "startq" ? {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            } : ""),
                                            ref: myQuestionBoxRef,
                                            children: questionsLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    minHeight: "130px",
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners__WEBPACK_IMPORTED_MODULE_40__/* ["default"] */ .Z, {
                                                    style: {
                                                        color: "".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary)
                                                    }
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        sx: {
                                                            display: "flex",
                                                            overflowX: "scroll",
                                                            "&::-webkit-scrollbar": {
                                                                display: "none"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            style: {
                                                                padding: "5px 5px",
                                                                fontFamily: "Roboto, Arial,  sans-serif",
                                                                fontSize: "20px",
                                                                fontWeight: 400,
                                                                width: "100%",
                                                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.palette_primary */ .T.palette_primary
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    sx: {
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        justifyContent: "space-between"
                                                                    },
                                                                    children: ((ref31 = currentTypeWriterQuestion()) === null || ref31 === void 0 ? void 0 : ref31.mainHeader) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopHeaderShow, {
                                                                        style: {
                                                                            lineHeight: "1.6rem"
                                                                        },
                                                                        children: (ref32 = currentTypeWriterQuestion()) === null || ref32 === void 0 ? void 0 : ref32.mainHeader
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    // Box around the typewriter question above the input box
                                                                    sx: {
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        justifyContent: "space-between",
                                                                        fontWeight: 400
                                                                    },
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((typewriter_effect__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                                        options: {
                                                                            strings: (ref33 = currentTypeWriterQuestion()) === null || ref33 === void 0 ? void 0 : ref33.question,
                                                                            autoStart: true,
                                                                            loop: false,
                                                                            delay: 30
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, (currentQuestionData === null || currentQuestionData === void 0 ? void 0 : (ref34 = currentQuestionData.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34[0]) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.answer_type) === null || ref36 === void 0 ? void 0 : ref36.trim()) == "startq" ? {
                                                            paddingTop: "0px",
                                                            display: "flex"
                                                        } : {
                                                            paddingTop: "25px",
                                                            display: "flex"
                                                        }),
                                                        children: inputGenerator()
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            sx: {
                                                width: "100%",
                                                backgroundColor: _src_tokens__WEBPACK_IMPORTED_MODULE_11__/* .tokens.token_grey_100 */ .T.token_grey_100,
                                                borderRadius: "16px",
                                                marginTop: "20px"
                                            },
                                            ref: myQuestionBoxRef,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                sx: {
                                                    padding: "25px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        sx: {
                                                            display: "flex"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    margin: "0 20px 0 0",
                                                                    cursor: "pointer"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                    src: (_public_assets_document_text_svg__WEBPACK_IMPORTED_MODULE_9___default()),
                                                                    height: "35px",
                                                                    width: "35px",
                                                                    onClick: handleOpenReviewModel
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    margin: "0 20px",
                                                                    cursor: "pointer"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                                    src: (_public_assets_email_svg__WEBPACK_IMPORTED_MODULE_10___default()),
                                                                    height: "35px",
                                                                    width: "35px",
                                                                    onClick: handleEmailButtonClick
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                            disableElevation: true,
                                                            variant: "contained",
                                                            sx: {
                                                                textTransform: "none",
                                                                height: "45px",
                                                                borderRadius: "14px",
                                                                whiteSpace: "nowrap"
                                                            },
                                                            onClick: handleSubmitReport,
                                                            disabled: getAgencyDataById.length === 0,
                                                            children: "Submit Report"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                open: openAddAgencyModel,
                onClose: handleAddAgencyClose,
                fullWidth: true,
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                        children: "Select agency"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        sx: {
                            padding: "0px 25px 0px 25px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                            children: filteredArrayAgency.length == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                sx: {
                                    margin: "25px 0",
                                    textAlign: "center"
                                },
                                children: "No agency found"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: filteredArrayAgency.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z, {
                                        onClick: function() {
                                            return handleAgencyDataClick(item);
                                        },
                                        sx: {
                                            padding: 0,
                                            margin: "10px 0",
                                            cursor: "pointer"
                                        },
                                        avatar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                                            variant: "rounded",
                                            src: item === null || item === void 0 ? void 0 : item.image,
                                            alt: "country-flag",
                                            sx: {
                                                width: 32,
                                                height: 24,
                                                border: "1px solid transparent"
                                            }
                                        }),
                                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EntityText, {
                                            sx: {
                                                fontSize: "0.775rem",
                                                lineHeight: "1.00rem"
                                            },
                                            children: item === null || item === void 0 ? void 0 : item.label
                                        }),
                                        subheader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OriginText, {
                                            sx: {
                                                fontSize: "0.775rem",
                                                lineHeight: "0.975rem"
                                            },
                                            children: item === null || item === void 0 ? void 0 : item.location
                                        })
                                    });
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            onClick: handleAddAgencyClose,
                            color: "primary",
                            children: "Close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                open: openBankDetailsPopUp,
                onClose: handleBankDetailsPopUpClose,
                fullWidth: true,
                maxWidth: "xs",
                onClick: handleBackdropClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
                    initialValues: initialValues,
                    validationSchema: validationSchema,
                    onSubmit: onSubmit,
                    children: function(param) {
                        var dirty = param.dirty, isValid = param.isValid, values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Security__WEBPACK_IMPORTED_MODULE_47__/* ["default"] */ .Z, {
                                            sx: {
                                                marginRight: "6px"
                                            }
                                        }),
                                        "Fraud Protection Block"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                                    sx: {
                                        padding: "0px 25px 0px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            sx: {
                                                margin: "16px 0"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                                                item: true,
                                                container: true,
                                                spacing: 2,
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Field */ .gN, {
                                                            label: "Bank Account Number",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "bankAccountNumber",
                                                            value: values.bankAccountNumber,
                                                            component: formik_mui__WEBPACK_IMPORTED_MODULE_48__/* .TextField */ .n
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Field */ .gN, {
                                                            label: "Bank Account Pin",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "bankAccountPin",
                                                            value: values.bankAccountPin,
                                                            component: formik_mui__WEBPACK_IMPORTED_MODULE_48__/* .TextField */ .n
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_38__/* ["default"] */ .ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Field */ .gN, {
                                                            label: "Bank Account Password",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "bankPassword",
                                                            value: values.bankPassword,
                                                            component: formik_mui__WEBPACK_IMPORTED_MODULE_48__/* .TextField */ .n
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_43__/* ["default"] */ .Z, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            onClick: handleBankDetailsPopUpClose,
                                            color: "primary",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            disableElevation: true,
                                            variant: "text",
                                            type: "submit",
                                            onSubmit: onSubmit,
                                            children: "Submit"
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_41__/* ["default"] */ .Z, {
                open: openReviewModel,
                onClose: handleCloseReviewModel,
                fullWidth: true,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_42__/* ["default"] */ .Z, {
                        children: "Review page"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_44__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_45__/* ["default"] */ .Z, {
                            children: tampBubble.map(function(item) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: item.map(function(qna) {
                                        var ref;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                    children: [
                                                        "Question:- ",
                                                        qna.question
                                                    ]
                                                }),
                                                typeof (qna === null || qna === void 0 ? void 0 : qna.answer) === "object" ? qna === null || qna === void 0 ? void 0 : (ref = qna.answer) === null || ref === void 0 ? void 0 : ref.map(function(answerData) {
                                                    return answerData.includes("image") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: answerData,
                                                        style: {
                                                            borderRadius: "10px",
                                                            margin: "2px"
                                                        },
                                                        height: "auto",
                                                        width: "190",
                                                        alt: "Converted to Base64"
                                                    }) : answerData.includes("application/pdf") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("embed", {
                                                        src: answerData,
                                                        type: "application/pdf",
                                                        style: {
                                                            borderRadius: "10px",
                                                            margin: "2px"
                                                        },
                                                        width: "350px",
                                                        height: "300px"
                                                    }) : "";
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        style: WebStyle.message_answer_review,
                                                        children: [
                                                            "Answer:-\xa0 ",
                                                            qna.answer
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, qna.id);
                                    })
                                }, item[0].id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_46__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            onClick: handleCloseReviewModel,
                            color: "primary",
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
}
interactive_report_new.propTypes = {
    /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */ window: (prop_types__WEBPACK_IMPORTED_MODULE_49___default().func)
};
/* harmony default export */ __webpack_exports__["default"] = (interactive_report_new);


/***/ }),

/***/ 15597:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQzLjc1IDE0LjU4MzJWMzUuNDE2NUM0My43NSA0MS42NjY1IDQwLjYyNSA0NS44MzMyIDMzLjMzMzMgNDUuODMzMkgxNi42NjY3QzkuMzc1IDQ1LjgzMzIgNi4yNSA0MS42NjY1IDYuMjUgMzUuNDE2NVYxNC41ODMyQzYuMjUgOC4zMzMxNyA5LjM3NSA0LjE2NjUgMTYuNjY2NyA0LjE2NjVIMzMuMzMzM0M0MC42MjUgNC4xNjY1IDQzLjc1IDguMzMzMTcgNDMuNzUgMTQuNTgzMloiIHN0cm9rZT0iIzBCMkIzQiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzAuMjA4MyA5LjM3NVYxMy41NDE3QzMwLjIwODMgMTUuODMzMyAzMi4wODMzIDE3LjcwODMgMzQuMzc1IDE3LjcwODNIMzguNTQxNiIgc3Ryb2tlPSIjMEIyQjNCIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi42NjY3IDI3LjA4MzVIMjUiIHN0cm9rZT0iIzBCMkIzQiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuNjY2NyAzNS40MTY1SDMzLjMzMzQiIHN0cm9rZT0iIzBCMkIzQiIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ 43109:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM1LjQxNjcgNDIuNzA4MkgxNC41ODM0QzguMzMzMzUgNDIuNzA4MiA0LjE2NjY5IDM5LjU4MzIgNC4xNjY2OSAzMi4yOTE1VjE3LjcwODJDNC4xNjY2OSAxMC40MTY1IDguMzMzMzUgNy4yOTE1IDE0LjU4MzQgNy4yOTE1SDM1LjQxNjdDNDEuNjY2NyA3LjI5MTUgNDUuODMzNCAxMC40MTY1IDQ1LjgzMzQgMTcuNzA4MlYzMi4yOTE1QzQ1LjgzMzQgMzkuNTgzMiA0MS42NjY3IDQyLjcwODIgMzUuNDE2NyA0Mi43MDgyWiIgc3Ryb2tlPSIjMEIyQjNCIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zNS40MTY2IDE4Ljc1TDI4Ljg5NTggMjMuOTU4M0MyNi43NSAyNS42NjY3IDIzLjIyOTEgMjUuNjY2NyAyMS4wODMzIDIzLjk1ODNMMTQuNTgzMyAxOC43NSIgc3Ryb2tlPSIjMEIyQjNCIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3517,4540,3835,1816,5426,877,517,2390,3408,9073,8346,594,4215,5675,1199,112,9643,7929,7841,5739,7404,9774,2888,179], function() { return __webpack_exec__(58165); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);